/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface CreditCardRecurrenceLogDetail {
  creditCardId?: number;
  creditCardRecurrenceLogId?: string;
  creditCardRecurrenceLogTypeId?: number;
  creditCardRecurrenceLogTypeName?: string;
  currentUser?: string;
  dateCreated?: Date;
  lastDigits?: string;
  message?: string;
  nameOnCard?: string;
  newLabel?: string;
  newValue?: number;
  oldLabel?: string;
  oldValue?: number;
  paymentContract?: string;
  paymentReference?: string;
  personId?: number;
  subscriberId?: number;
}
